module.exports = __webpack_public_path__ + "files/cae4f69f5f968cef6ed99bf54a528f89.png";